import { nth } from 'lodash'

const getAcronym = (name) => {
  if (!name) return ''
  return nth(name.match(/\(([^)]+)\)/), 1) || name
}

export { getAcronym }
